<template>
  <div class="type" :style="{ '--bg_color': bg_color }" @click="goRouter">
      <img class="lucency_Icon" src="../images/left_lcon.png">
      <div class="title">{{name}}</div>
      <div class="content">{{desc}}</div>
      <div :style="{ '--btn_color': btn_color }" class="btn">
        <img src="../images/jiantou.png">
      </div>
      <img class="icon" :src="icon">
    </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: {
    name: {
      type: String
    },
    bg_color: {
      type: String
    },
    btn_color: {
      type: String
    },
    icon: {
      type: String
    },
    app_url: {
      type: String
    },
    pc_url: {
      type: String
    },
    desc: {
      type: String
    },
    copywriter: {
      type: Array
    },
    isPc: {
      type: Boolean
    }
  },
  methods: {
    goRouter () {
      const { copywriter, isPc } = this
      if (!this.app_url && !this.pc_url) {
        Toast.fail('敬请期待')
        return
      }
      if (this.app_url.indexOf('https://') !== -1) {
        window.open(isPc ? this.pc_url : this.app_url, '_blank')
      } else {
        this.$router.push({
          path: isPc ? this.pc_url : this.app_url,
          query: {
            copywriter: copywriter.join('|')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.type {
  overflow: hidden;
  position: relative;
  width: 80%;
  height: 100px;
  background-color: var(--bg_color);
  border-radius: 10px;
  margin: 10px auto;
  .btn {
    position: relative;
    top: 73.5px;
    left: 20px;
    display: flex;
    align-items: center;
    width: 31px;
    height: 15px;
    background-color: var(--btn_color);
    opacity: 0.7;
    border-radius: 7.5px;
    img {
      width: 11px;
      height: 7.5px;
      margin: 0 auto;
    }
  }
  .title {
    position: absolute;
    top: 22.5px;
    left: 20.5px;
    font-weight: 600;
    color: #333333;
    z-index: 9;
    // margin: 22.5px 0 0 20.5px;
  }
  .content {
    position: absolute;
    top: 50px;
    left: 20px;
    font-size: 13px;
    color: #747171;
  }
  .icon {
    position: absolute;
    width: 74px;
    height: 64px;
    right: 0;
    bottom: 0;
  }
  .lucency_Icon {
    position: absolute;
    top: -20.5px;
    left: -21.5px;
    width: 70px;
    height: 73px;
  }
}
</style>
